import { Component, Inject, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTooltipModule } from '@angular/material/tooltip'

import { MonitoringService } from '../../../core/services/monitoring/monitoring.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'

interface MensagemMotoristaVm {
  codigoOs: string
  motoristaNome: string
  motoristaTelefone: string
  mensagem: string
  linkWhatsApp: string
  semMotorista: boolean
}

// O back monta a mensagem, não envia — não há integração de envio, o padrão do
// sistema é o operador abrir o link. linkWhatsApp vem vazio quando o motorista
// não tem telefone: desabilitar o botão, não abrir a busca de contatos do WhatsApp.
@Component({
  selector: 'modal-mensagem-motorista',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressBar, MatTooltipModule],
  templateUrl: './modal-mensagem-motorista.component.html',
  styleUrl: './modal-mensagem-motorista.component.scss',
})
export class ModalMensagemMotoristaComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { osId: string },
    private dialogRef: MatDialogRef<ModalMensagemMotoristaComponent>,
    private monitoringService: MonitoringService,
    private snackbar: SnackbarCustomService,
  ) {}

  loading = false
  mensagem: MensagemMotoristaVm | null = null

  ngOnInit(): void {
    this.loading = true
    this.monitoringService.getMensagemMotorista(this.data.osId).subscribe({
      next: (res: any) => { this.mensagem = res.data },
      error: (err: any) => { this.snackbar.errorRequest(err) },
      complete: () => { this.loading = false },
    })
  }

  copiar(): void {
    if (!this.mensagem) return
    navigator.clipboard.writeText(this.mensagem.mensagem)
    this.snackbar.success('Mensagem copiada.')
  }

  abrirWhatsApp(): void {
    if (!this.mensagem?.linkWhatsApp) return
    window.open(this.mensagem.linkWhatsApp, '_blank')
  }

  close(): void {
    this.dialogRef.close()
  }
}
